import gql from 'graphql-tag';
import { store } from 'Models/Store';
import { IProgramEntityAttributes } from 'Models/Entities';
import { Conditions, Has, OrderBy } from 'Util/QueryHelpers';

export const GET_PROGRAM_DETAILS_QUERY = gql`
	query getProgramName($id: ID) {
		programEntity(id: $id) {
			id
			title
			sourceProgramId
			code
			displayName
			formalAbbreviation
		}
	}
`;

export const SEARCH_PROGRAMS = gql`
	query getPrograms(
		$conditions: [[WhereExpressionGraph]],
		$has: [[HasConditionType]],
		$skip: Int,
		$take: Int,
		$orderBy: [OrderByGraph],
		$ids: [ID],
		$id: ID
	) {
		programEntitys(
			conditions: $conditions
			has: $has
			skip: $skip
			take: $take
			orderBy: $orderBy
			ids: $ids
			id: $id
	) {
			id
			code
			displayName
			formalAbbreviation
		}
	}
`;

export const getProgramById = async (id: string) => {
	return store.apolloClient
		.query<{ programEntity: IProgramEntityAttributes }>({
			query: GET_PROGRAM_DETAILS_QUERY,
			variables: {
				id,
			},
			fetchPolicy: 'network-only',
		});
};

export const getPrograms = async (
	conditions: Conditions,
	has: Has[][],
	orderBy: OrderBy,
	skip: number,
	take: number,
) => {
	const { data } = await store.apolloClient
		.query<{ programEntitys: IProgramEntityAttributes[] }>({
			query: SEARCH_PROGRAMS,
			fetchPolicy: 'network-only',
			variables: {
				conditions,
				has,
				orderBy,
				skip,
				take,
			},
		});

	return data.programEntitys;
};
